import { render, staticRenderFns } from "./modalOrdenTrabajo.vue?vue&type=template&id=3c216960&scoped=true&"
import script from "./modalOrdenTrabajo.vue?vue&type=script&lang=js&"
export * from "./modalOrdenTrabajo.vue?vue&type=script&lang=js&"
import style0 from "./modalOrdenTrabajo.vue?vue&type=style&index=0&id=3c216960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c216960",
  null
  
)

export default component.exports